import { generateUrlBase } from "../../../utils/utils";
import type { ApiCallerT } from "./types";
import type {
  CollaboratorsApiT,
  GetAllCollaboratorsResponseT,
} from "../types/collaborators.types";

export const createCollaboratorsApi = (
  apiCaller: ApiCallerT,
): CollaboratorsApiT => ({
  getAll: async () => {
    const url = generateUrlBase("collaborators");

    const response = await apiCaller<GetAllCollaboratorsResponseT>(
      url,
      "GET",
      {},
      {},
      {},
    );

    return response;
  },
});
